﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.PK, prompt: 'Personal Id' }),
        c_superior_id: new EntityColumn<string>({ name: 'c_superior_id', type: 'char', length: 20, flags: c.FK, prompt: 'Superior Id' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        peje_brwStandard: { name: 'peje_brwStandard', keyMappings: { c_superior_id: 0 } }
    }
)

const procs = () =>
(
    {
        peje_getJerarquiaPorPersonal: { name: 'peje_getJerarquiaPorPersonal' }
    }
)

export class PersonalJerarquiaDef extends EntityDefinition {

    columns = columns();
    views = views();

    procs = procs();

    constructor() {
        super('PersonalJerarquia');
    }
}